import _ from 'lodash';
import { createContext, useState, useEffect, ElementType, FC, ComponentProps, memo } from 'react';

const RESPONSIVE_BREAKPOINT: number = 991;

const isMobileView = (): boolean => {
  return window.innerWidth < RESPONSIVE_BREAKPOINT;
};

export const ResponsiveContext = createContext<boolean>(isMobileView());

export const WithResponsiveProvider = (WrappedComponent: ElementType) => {
  const ResponsiveProvider: FC<ComponentProps<typeof WrappedComponent>> = (props) => {
    const [isMobile, setIsMobile] = useState(isMobileView());

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(isMobileView());
      };
      const debouncedResize = _.debounce(handleResize, 150);
      window.addEventListener('resize', debouncedResize);

      return () => {
        window.removeEventListener('resize', debouncedResize);
        debouncedResize.cancel();
      };
    }, []);

    return (
      <ResponsiveContext.Provider value={isMobile}>
        <WrappedComponent {...props} />
      </ResponsiveContext.Provider>
    );
  };

  return memo(ResponsiveProvider);
};
